export default "__VITE_ASSET__C4vjj_eZ__"